module.exports = __webpack_public_path__ + "img/login_pt_code.ea51a067.png";